import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imSetEmail', {
        template: require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/auth/set_email/set_email.html'),
        controller: 'SetEmailController',
        controllerAs: 'SetEmailCtrl',
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/auth/set_email/set_email.component.ts